module.exports = __webpack_public_path__ + "static/media/bellIconBlue.33c3176b.svg";